import React from "react";
import Card from "react-bootstrap/Card";
import { Chart } from "react-google-charts";

function LineChart(props) {
  return (
    <Card className="dataStyle header">
        {props?.options?.title ?? "Trends"}
      <Chart
        chartType="LineChart"
        width="100%"
        height="300px"
        data={props?.data}
        options={props?.options}
      />
    </Card>
  );
}

export default LineChart;
